import sortList from '@root-gipro/modules/commonProjects/models/const/sort-list.const'
import {
	UserProjectActionsTypes,
	UserProjectsType,
} from '@root-gipro/modules/userProjects/models/interfaces/user-project.actions'
import {
	IUnc,
	IUserProject,
	IUserProjectState,
} from '@root-gipro/modules/userProjects/models/interfaces/user-projects.model'
import produce, { Draft } from 'immer'

const clearProject: IUserProject = {
	code: '',
	name: '',
	sumUncCost: null,
	sumUncCostWithNds: null,
	totalInvestmentUncOffer: null,
	yearBegin: null,
	yearEndOffer: null,
	actualFunding: null,
	valuationOfferForecast: null,
	additionalFundingOffer: null,
	offerRationale: '',
	years: {},
	regionIds: [],
	filialId: '',
	nds: null,
	t7Id: '',
	created_at: Math.floor(Date.now() / 1000),
	archived_at: 0,
	archive: 0,
	groupNum: '',
	phase: '',
	decreeName: '',
	decreeNumber: '',
	notExceeding: null,
	techConnect: false,
	onlyPIR: false,
	unc_auto_add: false,
	locked: false,
	t7Version: null,
	financial_needs: null,
	financial_needs_withNds: null,
	financial_needs_forecast: null,
	rps_unc_exceeding: null,
	version: '',
	versions: [],
	unc_sort: '2024',
	ipr_id: null,
}

const initialState: IUserProjectState = {
	projectList: [],
	totalInvestmentUncOfferSum: 0,
	paginationCounter: 0,
	userProjectsCnt: 0,
	originalObj: Object.assign(clearProject),
	projectObj: Object.assign(clearProject),
	isNew: false,
	activeUncs: [],
	uncs: [],
	uncsAnalog: [],
	targetVoltageValues: {},
	targetVoltageId: null,
	uncTableData: null,
	selectedElem: null,
	uncAddBuffer: [],
	uncCheckedTable: 6,
	uncFilter: '',
	projectFilter: '',
	interpolation: {},
	projectErrors: null,
	massErrors: null,
	sectionIds: [
		{ id: '1', name: 'Подготовка территории' },
		{ id: '2', name: 'ПИР' },
		{ id: '3', name: 'Задвоения с ячейками' },
		{ id: '4', name: 'Задвоения прочие' },
		{ id: '5', name: 'ВЛ' },
		{ id: '6', name: 'КЛ' },
		// { id: '7', name: 'Расстановка ПИР,С1/Б1' },
	],
	selectedSectionIds: [1, 2, 3, 4, 5, 6],
	loading: false,
	loadingAddUnc: false,
	uncEditMode: false,
	projectsErrors: false,
	sort: {
		name: sortList[0].name,
		sortName: sortList[0].sortName,
		order: true,
	},
	showLoader: false,
	showBackdropLoader: false,
	massCheckLoader: false,
	updateCalcLoader: false,
	t7Data: [],
	loadingT7Data: false,
	t7EditMode: false,
	allowMoreUserProjects: true,
	groupNum: '',
	phase: '',
	decreeName: '',
	decreeNumber: '',
	notExceeding: null,
	locked: false,
	exportable: true,
	task: null,
	f20link: null,
	t7Version: null,
	financial_needs: null,
	financial_needs_withNds: null,
	financial_needs_forecast: null,
	rps_unc_exceeding: null,
	deflators: null,
	nonStandardizedCosts: [],
	activeTotal: null,
	loadingStates: {},
	dataImportMagazine: {
		data: [],
		link: '',
	},
	openModalImportMagazine: false,
	uncFullInfo: null,
	uncCells: [],
	showWarningUncIds: [],
	enableUncAssist: true,
	isUncCanDeleted: true,
	progressPrecent: 0,
	investGroups: [],
	userProjects18Cnt: 0,
	userProjects24Cnt: 0,
	techSolutions: {
		userTechSolutions: [],
		resultsCnt: 0,
		order: '',
		page: 0,
	},
	loadSolutions: false,
	copyAlert: null,
	uncCellAssist: null,
	savedProjectTrigger: null,
	massErrorLoad: false,
  
  rpc: {
    isObjectsAnalogLoading: false,
    isObjectsAnalogExporting: false,
    objectsAnalog: null,
    addOAModal: {
      isOpen: false,
      isAdding: false,
      inputs: {
        oaId: null,
      }
    },
    deleteOAModal: {
      isOpen: false,
      isDeleting: false,
      idObjectAnalog: null
    }
  }
}

const userProjects = (draft: Draft<IUserProjectState>, action: UserProjectActionsTypes) => {
	switch (action.type) {
		case UserProjectsType.СHANGE_VERSION_NAME:
			draft.projectObj.version = action.versionName
			break

		case UserProjectsType.FETCH_REQUEST:
			draft.loading = true
			break
		case UserProjectsType.LOADING_USER_PROJECTS:
			draft.loading = action.loading
			break
		case UserProjectsType.CHANGE_UNC_CHECKED_TABLE:
			draft.uncCheckedTable = action.uncCheckedTable
			break
		case UserProjectsType.LOADING_T7DATA:
			draft.loadingT7Data = action.loading
			break
		case UserProjectsType.MASS_CHECK_LOADER:
			draft.massCheckLoader = action.loading
			break
		case UserProjectsType.SET_USER_PROJECTS:
			draft.projectList = action.projects
			draft.totalInvestmentUncOfferSum = Number(action.totalInvestmentUncOfferSum)
			draft.userProjectsCnt = action.userProjectsCnt
			draft.userProjects18Cnt = action.userProjects18Cnt
			draft.userProjects24Cnt = action.userProjects24Cnt
			break
		case UserProjectsType.ADD_USER_PROJECTS:
			draft.projectList = [...draft.projectList, ...action.projects]
			break
		case UserProjectsType.SET_USER_PROJECT_IN_LIST:
			draft.projectList = draft.projectList.map(initProject => {
				if (initProject.id === action.project.id) {
					return { ...initProject, locked: action.project.locked }
				} else {
					return initProject
				}
			})
			break
		case UserProjectsType.SET_ALLOW_MORE_USER_PROJECTS:
			draft.allowMoreUserProjects = action.allowMoreUserProjects
			break
		case UserProjectsType.SET_USER_PROJECTS_COUNT:
			draft.paginationCounter = action.paginationCounter
			break
		case UserProjectsType.CHOOSE_PROJECT:
			draft.projectObj = action.project
			break

		case UserProjectsType.SET_ORIGINAL_OBJ:
			draft.originalObj = action.project
			break

		case UserProjectsType.LOADING_ADD_UNC:
			draft.loadingAddUnc = action.loading
			break

		case UserProjectsType.SET_IS_NEW_PROJECT:
			draft.isNew = action.isNew
			break

		case UserProjectsType.SET_ACTIVE_UNCS:
			draft.activeUncs = action.uncs
			break
		//@ts-ignore
		case UserProjectsType.SET_ANALOG_UNC:
			//@ts-ignore
			draft.uncsAnalog = action.uncCells
			break
		case UserProjectsType.SET_PROJECT_UNCS:
			draft.loading = false
			draft.uncs = action.uncs
			break
		case UserProjectsType.SET_LOCKED_IN_LIST:
			draft.locked = action.locked
			break
		case UserProjectsType.SET_EXPORTABLE:
			draft.exportable = action.exportable
			break

		case UserProjectsType.SET_F20_TASK:
			draft.task = action.task
			break
		case UserProjectsType.SET_F20_LINK:
			draft.f20link = action.f20link
			break

		case UserProjectsType.SET_T7_DATA:
			draft.t7Data = action.t7Data
			break
		case UserProjectsType.SET_UNC_EDIT_MODE:
			draft.uncEditMode = action.mode
			break
		case UserProjectsType.SET_T7_EDIT_MODE:
			draft.t7EditMode = action.mode
			break
		case UserProjectsType.CREATE_PROJECT_TEMPLATE:
			draft.originalObj = clearProject
			draft.projectObj = clearProject
			break
		case UserProjectsType.SHOW_PROJECT_ERRORS:
			draft.projectsErrors = action.show
			break
		case UserProjectsType.CHECK_MASS_ERROR_LOAD:
			draft.massErrorLoad = action.massErrorLoad
			break
		case UserProjectsType.SET_PROJECT_NAME:
			draft.projectObj.name = action.name
			break

		case UserProjectsType.SET_PROJECT_СODE:
			draft.projectObj.code = action.code
			break
		case UserProjectsType.SET_PROJECT_YEARS:
			draft.projectObj.years = action.years
			break
		case UserProjectsType.SET_SELECTED_SECTION_IDS:
			draft.selectedSectionIds = action.selectedSectionIds
			break
		case UserProjectsType.SET_UNC_SORT:
			draft.projectObj.unc_sort = action.unc_sort
			break

		case UserProjectsType.SET_YEARS:
			draft.projectObj.yearBegin = action.begin
			draft.projectObj.yearEndOffer = action.end
			break

		case UserProjectsType.SET_REGION_IDS:
			draft.projectObj.regionIds = action.regionIds
			draft.originalObj.regionIds = action.regionIds
			break
		case UserProjectsType.SET_FILIAL_IDS:
			draft.projectObj.filialId = action.filialId
			draft.originalObj.filialId = action.filialId
			break

		case UserProjectsType.SET_VALUATION_OFFER_FORECAST:
			draft.projectObj.valuationOfferForecast = action.valuation
			break
		case UserProjectsType.SET_FINANCIAL_NEEDS:
			draft.projectObj.financial_needs_withNds = action.financial_needs_withNds
			break
		case UserProjectsType.SET_ADDITIONAL_FUNDING_OFFER:
			draft.projectObj.additionalFundingOffer = action.offer
			break
		case UserProjectsType.SET_OFFER_RATIONALE:
			draft.projectObj.offerRationale = action.offerRationale
			break
		case UserProjectsType.SET_ACTUAL_FUNDING:
			draft.projectObj.actualFunding = action.actualFunding
			break
		case UserProjectsType.SET_NDS:
			draft.projectObj.nds = action.nds
			break

		case UserProjectsType.SET_GROUP_TYPE:
			draft.projectObj.groupNum = action.groupNum
			break
		case UserProjectsType.SET_PHASE:
			draft.projectObj.phase = action.phase
			break
		case UserProjectsType.SET_DECREE_NAME:
			draft.projectObj.decreeName = action.decreeName
			break
		case UserProjectsType.SET_DECREE_NUM:
			draft.projectObj.decreeNumber = action.decreeNumber
			break
		case UserProjectsType.SET_NOT_EXCEED:
			draft.projectObj.notExceeding = action.notExceeding
			break

		case UserProjectsType.SET_UNC_TABLE_DATA:
			draft.uncTableData = action.uncTableData
			break
		case UserProjectsType.SELECT_TABLE_ELEM:
			draft.selectedElem = action.selectedElem
			break
		case UserProjectsType.SET_UNC_ADD_BUFFER:
			draft.loading = false
			draft.uncAddBuffer = action.buffer
			break
		case UserProjectsType.SET_UNC_FILTER_BUFFER:
			draft.loading = false
			draft.uncAddBuffer = action.buffer
			break
		case UserProjectsType.SET_UNC_FILTER:
			draft.uncFilter = action.filter
			break
		case UserProjectsType.SET_INTERPOLATION:
			draft.interpolation = action.obj
			break
		case UserProjectsType.SET_PROJECT_FILTER:
			draft.projectFilter = action.filter
			break
		case UserProjectsType.SET_PROJECT_ERRORS:
			draft.projectErrors = action.errors
			break
		case UserProjectsType.SET_MASS_ERRORS:
			draft.massErrors = action.errors
			break
		case UserProjectsType.SET_VOLTAGE:
			const indUncAddBuffer = draft.uncAddBuffer.findIndex(item => {
				if (item.id === action.uncId) return item
			})
			const indUncs = draft.uncs.findIndex(item => item.id === action.uncId)
			const newArrUncAddBuffer = draft.uncAddBuffer
			const newArrUncs = draft.uncs
			if (indUncAddBuffer >= 0) {
				newArrUncAddBuffer[indUncAddBuffer]['targetVoltageValues'] = action.targetVoltageValues
			}
			if (indUncs >= 0) {
				newArrUncs[indUncs]['targetVoltageValues'] = action.targetVoltageValues
			}
			draft.targetVoltageValues = action.targetVoltageValues // возможно нужно удаалить
			draft.uncAddBuffer = [...newArrUncAddBuffer]
			draft.uncs = [...newArrUncs]
			break
		case UserProjectsType.SET_VOLTAGE_ID:
			const indUncAddBuffer_ID = draft.uncAddBuffer.findIndex(item => item.id === action.uncId)
			const indUncs_ID = draft.uncs.findIndex(item => item.id === action.uncId)

			const newArrUncAddBuffer_ID = draft.uncAddBuffer
			const newArrUncs_ID: IUnc[] = draft.uncs
			if (indUncAddBuffer_ID >= 0) {
				newArrUncAddBuffer_ID[indUncAddBuffer_ID]['targetVoltageId'] = action.targetVoltageId
			}
			if (indUncs_ID >= 0) {
				newArrUncs_ID[indUncs_ID]['targetVoltageId'] = action.targetVoltageId
			}
			draft.targetVoltageId = action.targetVoltageId // возможно нужно удаалить
			draft.uncAddBuffer = [...newArrUncAddBuffer_ID]
			draft.uncs = [...newArrUncs_ID]
			break

		case UserProjectsType.SORT_USER_PROJECTS:
			draft.sort.name = action.name
			draft.sort.sortName = action.sortName
			draft.sort.order = action.order
			break
		case UserProjectsType.SHOW_LOADER:
			draft.showLoader = action.showLoader
			break
		case UserProjectsType.LOADING_UPDATE_CALC:
			draft.updateCalcLoader = action.loading
			break
		case UserProjectsType.TECH_CONNECT:
			draft.projectObj.techConnect = action.techConnect
			break
		case UserProjectsType.ONLY_PIR:
			draft.projectObj.onlyPIR = action.onlyPIR
			break
		case UserProjectsType.UNC_AUTO_ADD:
			draft.projectObj.unc_auto_add = action.unc_auto_add
			break
		case UserProjectsType.LOCKED:
			draft.projectObj.locked = action.locked
			break

		case UserProjectsType.SET_T7_VERSION:
			draft.projectObj.t7Version = action.t7Version
			draft.t7Version = action.t7Version
			break
		case UserProjectsType.SET_DEFLATORS:
			draft.deflators = { precision: action.precision, deflators: action.deflators }
			break
		case UserProjectsType.SET_NON_STANDARDIZED_COSTS:
			draft.nonStandardizedCosts = action.non_standardized_costs
			break
		case UserProjectsType.SET_ACTIVE_TOTAL:
			draft.activeTotal = action.activeTotal
			break
		case UserProjectsType.SET_LOADING_STATE:
			const { itemKey, isLoading } = action.payload
			if (itemKey === '') {
				Object.keys(draft.loadingStates).forEach(() => {
					draft.loadingStates = {}
				})
			} else {
				draft.loadingStates[itemKey] = isLoading
			}
			break
		case UserProjectsType.SET_DATA_IMPORT_MAGAZINE:
			draft.dataImportMagazine.data = action.data
			draft.dataImportMagazine.link = action.link
			break
		case UserProjectsType.SET_MODAL_OPEN_IMPORT_MAGAZINE:
			draft.openModalImportMagazine = action.open
			break
		case UserProjectsType.SET_UNC_FULL_INFO:
			draft.uncFullInfo = action.voltage
			break
		case UserProjectsType.SET_UNC_CELLS:
			draft.uncCells = action.uncCells
			break
		case UserProjectsType.SHOW_WARNING_UNC_KF:
			if (!draft.showWarningUncIds.includes(action.showWarningUncIds)) {
				draft.showWarningUncIds.push(action.showWarningUncIds)
			}
			break
		case UserProjectsType.SET_ASSIST_STATUS:
			draft.enableUncAssist = action.enableUncAssist
			break
		case UserProjectsType.DELETE_UNC_STATUS:
			draft.isUncCanDeleted = action.isDeleted
			break
		case UserProjectsType.SET_PROGRESS_UPDATE:
			draft.progressPrecent = action.progressPrecent
			break
		case UserProjectsType.UNC_CHANGE_COUNTER:
			const uncIndex = draft.uncs.findIndex(unc => unc.id == action.id)
			if (uncIndex !== -1) {
				draft.uncs[uncIndex].count = Number(action.newCount)
			}
			break
		case UserProjectsType.SET_INVEST_GROUP:
			draft.investGroups = action.investGroups
			break
		case UserProjectsType.SET_PROJECT_TECH_SOLUTIONS:
			if (
				action.page === 0 || // Если первая страница
				action.order !== draft.techSolutions.order // Если изменилась сортировка
			) {
				draft.techSolutions = {
					userTechSolutions: action.techSolutions, // Перезаписываем массив решений
					resultsCnt: action.resultsCnt, // Обновляем общее количество
					order: action.order, // Сохраняем новую сортировку
				}
			} else {
				draft.techSolutions.userTechSolutions = [...draft.techSolutions.userTechSolutions, ...action.techSolutions] // Добавляем данные при пагинации
				draft.techSolutions.resultsCnt = action.resultsCnt
			}
			break
		case UserProjectsType.SET_LOAD_PROJECT_SOLUTIONS:
			draft.loadSolutions = action.loadSolutions
			break
		case UserProjectsType.COPY_ALERT:
			draft.copyAlert = action.copyAlert
			break
		case UserProjectsType.SET_UNC_CELL_ASSIST:
			draft.uncCellAssist = action.uncCellAssist
			break
		case UserProjectsType.SAVED_USER_PROJECT_TRIGGER:
			draft.savedProjectTrigger = action.noid
			break
    
    case UserProjectsType.SET_PROJECT_RPC: {

      draft.rpc = {
				...draft.rpc,
				...action.params,
			}
      
			break;
		}
      
    case UserProjectsType.SET_PROJECT_ADD_OA_MODAL: {

      if (action.params === null) {
        draft.rpc.addOAModal = initialState.rpc.addOAModal
      } else {
        draft.rpc.addOAModal = {
          ...draft.rpc.addOAModal,
          ...action.params,
          inputs: {
            ...draft.rpc.addOAModal.inputs,
            ...action.params.inputs
          }
        }
      }

      break;
    }

    case UserProjectsType.UPDATE_PROJECT_RPC: {
      const { actionType, data } = action.params;

      if(actionType === 'push') {
        draft.rpc.objectsAnalog = [
          ...draft.rpc.objectsAnalog,
          data
        ]
      }

      break;
    }

    case UserProjectsType.SET_PROJECT_DELETE_MODAL_OA: {
      if (action.params === null) {
        draft.rpc.deleteOAModal = initialState.rpc.deleteOAModal
      } else {
        draft.rpc.deleteOAModal = {
          ...draft.rpc.deleteOAModal,
          ...action.params,
        }
      }

      break;
    }

    case UserProjectsType.SET_PROJECT_OA_INPUTS: {

      const { idObjectAnalog, value, name } = action.params;

      if(draft.rpc.objectsAnalog) {
        
        draft.rpc.objectsAnalog.forEach((obj: any, i: number) => {
          
          if((obj.id === idObjectAnalog) && (name in obj)) {
            
            draft.rpc.objectsAnalog[i][name] = value;
          }
        })
      }

      break;
    }

    case UserProjectsType.SET_DELETED_PROJECT_OA: {

      const { idObjectAnalog, status } = action.params;

      if (status === 'success' && draft.rpc.objectsAnalog) {
        draft.rpc.objectsAnalog = draft.rpc.objectsAnalog.filter((obj: any) => obj.id !== idObjectAnalog);
      }

      break;
    }
      
    default:
			return draft
	}
}

export const userProjectsReducer = produce(userProjects, initialState)
